import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ea812a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-box relative" }

import LoadingSpinner from "./LoadingSpinner.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingBox',
  props: {
    isLoading: { type: Boolean, default: false },
    spinnerSize: { default: "60px" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(LoadingSpinner, {
              key: 0,
              class: "spinner",
              size: _ctx.spinnerSize
            }, null, 8, ["size"]))
          : _renderSlot(_ctx.$slots, "default", { key: 1 })
      ]),
      _: 3
    })
  ]))
}
}

})